import { socialLinks } from "@/data/main-data";
import { Mail, MapPinMinus, Phone } from "lucide-react";
import { useLocale } from "next-intl";
import Link from "next/link";
import React from "react";

export default function ContactInfo() {
  const locale = useLocale();

  const address =
    locale === "en"
      ? "N1 - District 4811, Said Zakaria St, Sheraton, Cairo, Egypt"
      : "المبنى N1 - الحي 4811، شارع سعيد زكريا، شيراتون، القاهرة، مصر";

  return (
    <div className="space-y-4">
      <h4 className="text-xl font-semibold">
        {locale === "en" ? "Get in Touch" : "تواصل معنا مباشرة"}
      </h4>

      <div className="flex flex-col gap-3 text-muted-foreground">
        <Link href="tel:+201501270003" className="flex items-center gap-3">
          <Phone className="w-5 h-5 text-[#c9a24d]" />
          <span
            style={{
              unicodeBidi: "plaintext",
            }}
          >
            +20 150 127 0003
          </span>
        </Link>
        <Link href="tel:+966564279751" className="flex items-center gap-3">
          <Phone className="w-5 h-5 text-[#c9a24d]" />
          <span
            style={{
              unicodeBidi: "plaintext",
            }}
          >
            +966 56 427 9751
          </span>
        </Link>
        <Link
          href="mailto:info@logichubeg.com"
          className="flex items-center gap-3"
        >
          <Mail className="w-5 h-5 text-[#c9a24d]" />
          <span>info@logichubeg.com</span>
        </Link>
        <div className="flex items-center gap-3">
          <MapPinMinus className="w-5 h-5 text-[#c9a24d]" />
          <span>{address}</span>
        </div>
      </div>

      {/* Social Links */}
      <div className="flex items-center gap-4 pt-4">
        {socialLinks.map((link) => (
          <Link
            href={link.url}
            key={link.name}
            target="_blank"
            rel="noopener noreferrer"
            className="p-3 rounded-full border border-border hover:border-[#c9a24d] hover:bg-[#c9a24d]/10 transition"
          >
            <link.icon size={32} className="text-[#c9a24d]" />
          </Link>
        ))}
      </div>
    </div>
  );
}
